<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-right-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <!-- <el-form-item label="">
            <el-select filterable v-model="queryForm.typehood" placeholder="订单类型" clearable>
              <el-option v-for="item in typehoods" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="">
            <el-input
              v-model.trim="queryForm.keyword"
              clearable
              placeholder="订单号/订单标题/姓名/手机号"
            />
          </el-form-item>
          <!-- <el-form-item label="">
            <el-select filterable v-model="queryForm.step" placeholder="订单状态" clearable>
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="">
            <el-select filterable v-model="queryForm.channel" placeholder="支付类型" clearable class="mr-10">
              <el-option v-for="item in channels" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="订单号"
        prop="basic.orderNo"
        show-overflow-tooltip
        width="150"
      />
      <el-table-column
        align="left"
        label="标题"
        prop="title"
        width="250"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="订单类型"
        show-overflow-tooltip
      >
        <template #default="{ row }">
           {{ typehoods.find(e => e.value == row.typehood).label }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="订单金额"
        show-overflow-tooltip
      >
        <template #default="{ row }">
           {{ row.amount && row.amount && row.amount.payAmount }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="退款金额"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ row.amount && row.amount && row.amount.refundAmount }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="联系人姓名"
        show-overflow-tooltip
        width="150"
      >
        <template #default="{ row }">
          {{ row.basic && row.basic.contact && row.basic.contact.name }}
        </template>
      </el-table-column><el-table-column
        align="left"
        label="联系人生日"
        show-overflow-tooltip
        width="100"
      >
        <template #default="{ row }">
          {{ row.basic && row.basic.contact && row.basic.contact.birthday }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="联系人性别"
        show-overflow-tooltip
        width="100"
      >
        <template #default="{ row }">
          {{ row.basic && row.basic.contact && row.basic.contact.gender }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="联系人手机号"
        show-overflow-tooltip
        width="150"
      >
        <template #default="{ row }">
          {{ row.basic && row.basic.contact && row.basic.contact.tel }}
        </template>
      </el-table-column>
      
      <el-table-column
        align="left"
        label="订单状态"
        show-overflow-tooltip
        width="150"
      >
        <template #default="{ row }">
          <el-tag type="primary" v-if="row.step==1">待付款</el-tag>
          <el-tag type="success" v-if="row.step==2">已预约</el-tag>
          <el-tag type="warning" v-if="row.step==3">待注册</el-tag>
          <el-tag type="success" v-if="row.step==4">已完成</el-tag>
          <el-tag type="danger" v-if="row.step==5">已退款</el-tag>
          <el-tag type="info" v-if="row.step==6">已取消</el-tag>
          <el-tag type="warning" v-if="row.step==8">退款中</el-tag>
          <el-tag type="warning" v-if="row.step==9">待确认</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="创建时间"
        prop="created"
        width="160"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="120"
      >
        <template #default="{ row }">
          <el-button type="text" @click="handleShow(row)">详情</el-button>
          <el-button type="text" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <ApartmentDetail ref="apartment" @fetch-data="fetchData" />
  </div>
</template>

<script>
import moment from 'moment'
import { getApartmentOrders, delApartmentOrder } from '@/api/order'
import { orderTypehoods, orderChannels, orderChannelOptions, orderSteps, orderTypehood } from '@/utils/const'
import ApartmentDetail from './detail.vue'
export default {
  name: 'List',
  components: { ApartmentDetail },
  data() {
    return {
      moment,
      typehoods: orderTypehoods,
      channels: orderChannelOptions,
      options: orderSteps,
      list: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      queryForm: {
        page: 1,
        size: 10,
        keyword: '',
        step: '',
        channel: '',
        typehood: '',
      },
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/order/apartment') {
        this.fetchData()
      }
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleShow(row){
      this.$refs.apartment.show(row)
    },
    // 删除订单
    handleDelete(row) {
      this.$prompt(
        '请输入删除原因（选填）',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }
      ).then(async ({ value }) => {
        const result = await delApartmentOrder({
          orderId: row.orderId,
          removeReason: value
        })
        this.$message.success('删除成功')
        this.fetchData()
      })
    },
    // 格式化订单支付方式
    formatChannel(row) {
      const channel = row && row.payment && row.payment.channel || 'UNKOWN'
      return orderChannels[channel]
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const { list, total } = await getApartmentOrders(this.queryForm)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.diy-dropdown-menu {
  padding: 8px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;

  & + .el-button {
    margin-left: 10px!important;
  }
}
.vab-query-form {
  :deep() {
    .el-form-item + .el-form-item {
      margin: 0 0 10px 10px !important;

      .el-button {
        margin: 0 0 0 0 !important;
      }
    }
  }
}
.avatar {
  height: 64px;
  width: 128px;
  border-radius: 8px;
}
</style>
